import { Button } from 'hatch-components';
import styled from 'styled-components';

export const StyledDefaultTemplateLeftColumnButton = styled(Button)(
  ({ isLogoutButton, active, theme: { spacing, colors, border, font } }) => ({
    '#download-icon': {
      'path, line': {
        stroke: colors.error,
      },
    },
    '&:hover': {
      '#download-icon': {
        'path, line': {
          stroke: colors.white,
        },
      },
      background: (() => {
        if (isLogoutButton) {
          return colors.errorHighlight;
        }
        if (active) {
          return colors.secondary;
        }
        return colors.primaryHighlight;
      })(),
      color: (() => {
        if (isLogoutButton) {
          return colors.error;
        }
        if (active) {
          return colors.white;
        }
        return colors.primary;
      })(),
      cursor: active ? 'default' : 'pointer',
      svg: {
        '#dollar-svg-path': {
          fill: active ? colors.white : colors.primary,
          stroke: 'none',
        },
        '&#download-icon': {
          'path, line': {
            stroke: colors.error,
          },
        },
        '.apps-icon-circle': {
          fill: active ? colors.secondary : colors.primaryHighlight,
        },
        '.home-icon-path': {
          fill: active ? colors.white : colors.primary,
          stroke: 'none',
        },
        '.team-icon-path': {
          fill: active ? colors.secondary : colors.primaryHighlight,
        },
        '.team-icon-path-white': {
          fill: active ? colors.secondary : colors.primaryHighlight,
          stroke: active ? colors.secondary : colors.primaryHighlight,
        },
        '.userverified-icon-path': {
          fill: active ? colors.white : colors.primary,
          stroke: active ? colors.white : colors.primary,
        },
        marginRight: 16,
        'path, line, rect, circle': {
          fill: 'none',
          stroke: active ? colors.white : colors.primary,
        },
      },
    },
    alignItems: 'center',
    background: active && colors.secondary,
    borderRadius: border.radius.md,
    color: (() => {
      if (isLogoutButton) {
        return colors.error;
      }
      if (active) {
        return colors.white;
      }
      return colors.secondary;
    })(),
    display: 'flex',
    flexDirection: 'row',
    fontSize: font.size.md,
    fontWeight: font.weight.normal,
    height: 36,
    justifyContent: 'flex-start',
    lineHeight: font.lineHeight.md,
    margin: `0 ${spacing.md} ${isLogoutButton ? 0 : spacing.sm} ${spacing.md}`,
    padding: `0 ${spacing.sm}`,
    svg: {
      '#dollar-svg-path': {
        fill: active ? colors.white : colors.secondary,
        stroke: 'none',
      },
      '.apps-icon-circle': {
        fill: active ? colors.secondary : colors.white,
      },
      '.home-icon-path': {
        fill: active ? colors.white : colors.secondary,
        stroke: 'none',
      },
      '.team-icon-path': {
        fill: active ? colors.secondary : colors.white,
      },
      '.team-icon-path-white': {
        fill: active ? colors.secondary : colors.white,
        stroke: active ? colors.secondary : colors.white,
      },
      '.userverified-icon-path': {
        fill: active ? colors.white : colors.secondary,
        stroke: active ? colors.white : colors.secondary,
      },
      marginRight: 16,
      'path, line, rect, circle': {
        fill: 'none',
        stroke: active ? colors.white : colors.secondary,
      },
    },
    textAlign: 'left',
    width: `calc(100% - ${spacing.md} - ${spacing.md})`,
  }),
);
